import { render } from "./results-report.vue?vue&type=template&id=40c1f585&scoped=true&ts=true"
import script from "./results-report.vue?vue&type=script&lang=ts"
export * from "./results-report.vue?vue&type=script&lang=ts"

import "./results-report.vue?vue&type=style&index=0&id=40c1f585&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c1f585"]])

export default __exports__